import { render, staticRenderFns } from "./alertItem.vue?vue&type=template&id=ff815244&scoped=true&"
import script from "./alertItem.vue?vue&type=script&lang=js&"
export * from "./alertItem.vue?vue&type=script&lang=js&"
import style0 from "./alertItem.vue?vue&type=style&index=0&id=ff815244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff815244",
  null
  
)

component.options.__file = "alertItem.vue"
export default component.exports